"use client";

import { c as _c } from "react/compiler-runtime";
import { IconArrowRight } from "@tabler/icons-react";
import Link from "next/link";
import { trackSearchSubmitted } from "@/lib/analytics/segment";
import { scrubQueryClient } from "@/lib/search/clientPiiScrub";
import { useSearchPanelStore } from "@/stores/useSearchPanelStore";
interface Props {
  query: string;
  total: number;
}
export function SearchViewAllLink(t0) {
  const $ = _c(13);
  const {
    query,
    total
  } = t0;
  const close = useSearchPanelStore(_temp);
  let t1;
  if ($[0] !== query) {
    t1 = scrubQueryClient(query);
    $[0] = query;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const safe = t1;
  const t2 = `/products?q=${encodeURIComponent(safe)}`;
  let t3;
  if ($[2] !== close || $[3] !== safe || $[4] !== total) {
    t3 = () => {
      trackSearchSubmitted({
        query: safe,
        resultCount: total,
        source: "autocomplete"
      });
      close();
    };
    $[2] = close;
    $[3] = safe;
    $[4] = total;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== total) {
    t4 = <span>View All Search Results ({total})</span>;
    $[6] = total;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <IconArrowRight className="size-4" />;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
    t6 = <Link href={t2} onClick={t3} className="flex items-center justify-between gap-2 rounded-md py-3 text-sm font-semibold text-foreground no-underline! hover:opacity-100!">{t4}{t5}</Link>;
    $[9] = t2;
    $[10] = t3;
    $[11] = t4;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  return t6;
}
function _temp(state) {
  return state.close;
}